import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';

import {ValveFamilyInputValveFamiliesQuery} from './__generated__/ValveFamilyInputValveFamiliesQuery.graphql';
import DropdownInput from './DropdownInput';

type Props = {
  value: string;
  manufacturerId: string;
  onChange: (value: string) => void;
  error?: string;
};

function ValveFamilyInput(props: Props) {
  const {value, manufacturerId, onChange, error} = props;

  const data = useLazyLoadQuery<ValveFamilyInputValveFamiliesQuery>(
    valveFamiliesQuery,
    {manufacturerId: props.manufacturerId},
    {fetchPolicy: 'store-and-network'},
  );

  const options =
    !!data && manufacturerId
      ? data.valveFamilies.edges
          .filter(valveFamilyEdge => valveFamilyEdge.node.manufacturer.id === manufacturerId)
          .map(valveFamilyEdge => ({
            label: valveFamilyEdge.node.name,
            value: valveFamilyEdge.node.id,
          }))
      : [];

  return (
    <DropdownInput
      name="valveFamilyInput"
      onChange={onChange}
      options={options}
      placeholder="E.g. Gate Valve"
      label="Type"
      value={value}
      error={error}
    />
  );
}

const valveFamiliesQuery = graphql`
  query ValveFamilyInputValveFamiliesQuery {
    valveFamilies {
      edges {
        node {
          id
          name
          manufacturer {
            id
          }
        }
      }
    }
  }
`;

export default ValveFamilyInput;
